import type { Issue, IssueSibling } from '~/api/help-center/types/Issue.types'
import type { ProblemResponse } from '~/api/help-center/types/Problem.types'

export const PROGRESS_BAR_INCREMENT_PERCENTAGE = 15
export const PROGRESS_BAR_MAX_STEPS = 4

export const actors: Record<string, string> = {
  Modal: 'modal',
  Toast: 'toast',
}

export const events = {
  always: {
    type: '',
  } as {
    type: ''
    skipModal?: boolean
  },
  continueWithSelectedIssues: { type: 'CONTINUE_WITH_SELECTED_ISSUES' },
  doInvoiceRequest: {
    type: 'done.invoke.doInvoiceRequest',
    data: {} as unknown,
  },
  doInvoiceRequestFailed: {
    type: 'error.platform.doInvoiceRequest',
    data: {} as unknown,
  },
  getAction: {
    type: 'done.invoke.getAction',
    data: {} as ProblemResponse['action'],
  },
  getActionFailed: {
    type: 'error.platform.getAction',
    data: {} as unknown,
  },
  getIssues: {
    type: 'done.invoke.getIssues',
    data: {} as Issue[],
  },
  getIssuesFailed: {
    type: 'error.platform.getIssues',
    data: {} as unknown,
  },
  goBack: { type: 'GO_BACK' },
  modalClosed: { type: 'MODAL_CLOSED' },
  retry: { type: 'RETRY' },
  selectIssues: {
    type: 'SELECT_ISSUES',
    selectedIssues: [],
  } as {
    type: 'SELECT_ISSUES'
    selectedIssues: IssueSibling[] | IssueSibling | null
    skipModal?: boolean
  },
  sendAnotherInvoiceRequest: { type: 'SEND_ANOTHER_INVOICE_REQUEST' },
  toastClosed: {
    type: 'TOAST_CLOSED',
  },
  updateOrderlineContext: {
    type: 'UPDATE_ORDERLINE_CONTEXT',
  } as {
    type: 'UPDATE_ORDERLINE_CONTEXT'
    payload: {
      orderId: number | null
      mobileServicePartnerProviderLabel: string | null
      mobileServicePartnerProviderUrl: string | null
    }
  },
} as const

export const toasts = {
  RequestFailed: 'REQUEST_FAILED',
}
